/* ==========================================================================
   MODESSIMA LUXE — Core JS (vanilla, no dependencies)
   ========================================================================== */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initStickyHeader();
    initMobileMenu();
    initCartDrawer();
    initRevealOnScroll();
    initQuantityInputs();
    initProductGallery();
  });

  /* Sticky header shadow on scroll */
  function initStickyHeader() {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;
    var onScroll = function () {
      if (window.scrollY > 12) {
        header.classList.add('is-sticky');
      } else {
        header.classList.remove('is-sticky');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Mobile drawer menu */
  function initMobileMenu() {
    var trigger = document.querySelector('[data-menu-open]');
    var closeBtn = document.querySelector('[data-menu-close]');
    var menu = document.querySelector('[data-mobile-menu]');
    var overlay = document.querySelector('[data-menu-overlay]');
    if (!trigger || !menu) return;

    function open() {
      menu.classList.add('is-open');
      overlay && overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      menu.classList.remove('is-open');
      overlay && overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      trigger.setAttribute('aria-expanded', 'false');
    }
    trigger.addEventListener('click', open);
    closeBtn && closeBtn.addEventListener('click', close);
    overlay && overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* Cart drawer: open/close + AJAX add-to-cart */
  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-menu-overlay]');
    var openTriggers = document.querySelectorAll('[data-cart-open]');
    var closeBtn = document.querySelector('[data-cart-close]');

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      overlay && overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      overlay && overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    openTriggers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });
    closeBtn && closeBtn.addEventListener('click', closeDrawer);
    overlay && overlay.addEventListener('click', closeDrawer);

    /* Intercept product forms for AJAX add to cart */
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' }
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add_to_cart_failed');
            return res.json();
          })
          .then(function () {
            refreshCartDrawer();
            openDrawer();
          })
          .catch(function () {
            form.submit();
          });
      });
    });

    function refreshCartDrawer() {
      if (!drawer) return;
      fetch('/?section_id=cart-drawer')
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer]');
          if (fresh) {
            drawer.innerHTML = fresh.innerHTML;
            initCartDrawer();
          }
        });
    }

    /* Quantity / remove inside drawer via cart change API */
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      var remove = e.target.closest('[data-cart-remove]');
      if (minus || plus) {
        var wrap = (minus || plus).closest('[data-cart-item]');
        var input = wrap.querySelector('input[type="number"]');
        var key = wrap.getAttribute('data-key');
        var qty = parseInt(input.value, 10) || 1;
        qty = minus ? Math.max(0, qty - 1) : qty + 1;
        updateCartLine(key, qty);
      }
      if (remove) {
        var itemWrap = remove.closest('[data-cart-item]');
        updateCartLine(itemWrap.getAttribute('data-key'), 0);
      }
    });

    function updateCartLine(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () {
        refreshCartDrawer();
      });
    }
  }

  /* Fade-in / slide-up reveal on scroll */
  function initRevealOnScroll() {
    var items = document.querySelectorAll('.reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    items.forEach(function (el) { observer.observe(el); });
  }

  /* Generic quantity steppers (product page / cart) */
  function initQuantityInputs() {
    document.querySelectorAll('[data-quantity-wrapper]').forEach(function (wrap) {
      var input = wrap.querySelector('input[type="number"]');
      var minus = wrap.querySelector('[data-quantity-minus]');
      var plus = wrap.querySelector('[data-quantity-plus]');
      if (!input) return;
      minus && minus.addEventListener('click', function () {
        input.value = Math.max(parseInt(input.min || '1', 10), (parseInt(input.value, 10) || 1) - 1);
        input.dispatchEvent(new Event('change'));
      });
      plus && plus.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
        input.dispatchEvent(new Event('change'));
      });
    });
  }

  /* Product page gallery: swap main image on thumbnail click */
  function initProductGallery() {
    var main = document.querySelector('[data-gallery-main-image]');
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full-src');
        if (!full) return;
        main.src = full;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }
})();
